import { useNavigate } from 'react-router-dom';
import { heroContainer } from '../../../Constants/Styles';

const Hero = () => {
    const navigate = useNavigate();
    return (
        <div className="w-full">
            <div className={heroContainer} style={{ backgroundImage: `url(https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/BackgroundImage.png)` }}>

                <div className="w-full p-8 xl:px-32 2xl:px-48 flex flex-col">
                    <div className="w-full md:w-[40rem] lg:w-[52rem] 2xl:w-[58rem] text-center md:text-left sm:px-6 text-5xl xs:text-5xl md:text-6xl xl:text-7xl 2xl:text-8xl text-heroTitleText font-all-round-gothic-bold">CharmHealthHub Admin Portal</div>

                    <div className=" mt-10 sm:mt-12 w-full md:w-[42.8rem] lg:w-[45rem] 2xl:w-[50rem] text-center md:text-left sm:px-6 text-xl md:text-2xl 2xl:text-3xl text-heroSubtitleText font-proxima-nova"></div>

                    <div className="w-full mt-10 md:w-[40rem] lg:w-[52rem] 2xl:w-[58rem]  sm:px-6 items-center flex items-center">
                        <button
                            className="text-white text-2xl px-6 py-2 bg-charmOrange w-fit mx-auto rounded-full mx-auto "
                            onClick={() => navigate('/admins/login')}
                        >Login </button>
                    </div>
                </div>


            </div>
        </div>

    );
}

export default Hero;